import React from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import '../../../style/main.scss';
import { BottomSheet } from '../../../app/common/sharedComponents/BottomSheet';

export const bottomSheet = (
  imageData,
  openImage,
  setOpenImage,
  selectedUrl,
  setSelecedUrl,
  notes,
  setNotes
) => {
  if (!imageData) {
    return;
  }

  return (
    <BottomSheet isOpen={openImage} onClose={() => setOpenImage(false)}>
      <Block>
        <div
          className="text-center pb-70"
          style={{
            maxHeight: 'calc(100vh - 185px)',
          }}
        >
          <div
            className={`p-150 ${selectedUrl ? 'd-block' : 'd-none'} selected-image`}
          >
            <img src={selectedUrl} height={250} width={350} />
          </div>
          <span className="text-left fw-400 f-15 lh-20 color-1F1F1F mr-22 mt-20 mb-20">
            Photos:{imageData.length}
          </span>
          <span className="text-right fw-400 f-15 lh-20 color-1F1F1F ml-20 mt-20 mb-20">
            {notes}
          </span>
          <div className="image-container">
            {imageData.map((image) => (
              // tslint:disable-next-line:jsx-key
              <div>
                <img
                  src={image.url}
                  height={77}
                  width={76}
                  onClick={() => {
                    setSelecedUrl(image.url);
                    setNotes(image.notes);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </Block>
    </BottomSheet>
  );
};
